<template>
  <div class="take-detail-list">
    <div class="deatil-title">
      <!-- <span> $vi18n('$i18n# 提现记录 #i18n$') </span> -->
      <!-- <span class="btn-more btn" @click="moreSettleDetail"> $vi18n('$i18n# 查看更多 #i18n$') </span> -->
    </div>
    <settlementDetail> </settlementDetail>
    <!-- <Table
      v-loading="loading"
      :tableData="tableData"
      :tableField="tableField"
      key="incomeHomeTable"
      :tableInfo="tableInfo"
      :isShowPagination="false"
      :tabletype="true"
    ></Table> -->
  </div>
</template>

<script>
// import Table from '../table';
import settlementDetail from '../../settlementDetail.vue';
import { getRecordList } from '@/api/income';
import { $vi18n } from '@/utils/i18n.js';
export default {
  name: 'indexPageTable',
  components: {
    // Table
    settlementDetail,
  },
  props: {
    isRefreshTable: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    isRefreshTable(val) {
      if (val) {
        this.fetchRecordList();
      }
    },
  },
  data() {
    return {
      tableInfo: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      defaultStart:
        new Date(
          new Date(new Date() - 3600 * 1000 * 24 * 30 * 3).toString(),
        ).getTime() / 1000, // 0$vi18n('$i18n# 点时间戳 #i18n$')
      defaultEnd:
        new Date(new Date(new Date()).toString()).getTime() / 1000 +
        (24 * 60 * 60 - 1), // $vi18n('$i18n# 当天 #i18n$')23:59:59$vi18n('$i18n# 点时间戳 #i18n$')
      tableData: [],
      //noData:'three',
      tableField: [
        { label: $vi18n('$i18n# 日期 #i18n$'), prop: 'time' },
        {
          label: $vi18n('$i18n# 订单号 #i18n$'),
          prop: 'id',
        },
        {
          label: $vi18n('$i18n# 类型 #i18n$'),
          prop: 'money_type',
        },
        {
          label: $vi18n('$i18n# 提现数额 #i18n$'),
          prop: 'money',
        },
        {
          label: $vi18n('$i18n# 税费 #i18n$'),
          prop: 'taxe',
        },
        {
          label: $vi18n('$i18n# 手续费 #i18n$'),
          prop: 'service_charge',
        },
        {
          label: $vi18n('$i18n# 到账金额 #i18n$'),
          prop: 'real_money',
        },
        {
          label: $vi18n('$i18n# 状态 #i18n$'),
          prop: 'state',
        },
        {
          label: $vi18n('$i18n# 操作 #i18n$'),
          prop: 'operation',
        },
      ],
      loading: false,
    };
  },
  mounted() {
    this.fetchRecordList();
  },
  methods: {
    moreSettleDetail() {
      //$vi18n('$i# 结算中心 #i18n$')-$vi18n('$i1# 查看更多点击埋点 #i18n$')
      this.$log('check_more_click', 85433, { v7: 1 });
      this.$router.push({ name: 'settlementDetail' });
    },
    async fetchRecordList() {
      try {
        this.loading = true;
        let data = {
          // $vi18n('$i# 默认请求最近一月 #i18n$')
          money_type: 999,
          start_time: this.defaultStart,
          end_time: this.defaultEnd,
          page: this.tableInfo.page,
          page_size: this.tableInfo.pageSize,
          dtype: 1,
        };
        const res = await getRecordList(data);

        this.tableData = res.data.list;
        this.tableInfo.total = res.data.total_count;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$--color-primary: #fd9b21;

.take-detail-list {
  //margin-top: 30px;
  margin-bottom: 500px;
  .deatil-title {
    font-size: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 18px;
    .btn-more {
      width: 130px;
      height: 36px;
      background: #fffaed;
      border: 1px solid #ffc973;
      border-radius: 18px;
      font-size: 16px;
      color: $--color-primary;
      line-height: 36px;
      text-align: center;
    }
  }
  .btn {
    cursor: pointer;
    &:hover {
      filter: brightness(105%);
    }
  }
  .btn-forbid {
    background: #d9d9d9 !important;
    &:hover {
      filter: brightness(100%);
    }
  }
}
</style>
